import { DataModelBuilder, SerializationContext, SerializedData, DataModel } from '../../dto/data-model.js';
import { MapUtils } from '../../../utility/map-utils.js';
import { toEnumFromString } from '../../../serialization/enum-utils.js';

export enum SeatPreviewStatus {
  Free = 'Free',
  Unavailable = 'Unavailable',
  Hovered = 'Hovered',
  Selected = 'Selected',
}

export class SeatPreviewState extends DataModel {
  static readonly TYPE_ID = 'cfee229edaa841619ef4b83627a0b9b7';

  private constructor(
    public readonly seatId: number,
    public readonly seatPreviewStatus: SeatPreviewStatus,
  ) {
    super();
  }

  get $typeId(): string {
    return SeatPreviewState.TYPE_ID;
  }

  static create(args: {
    seatId: number;
    seatPreviewStatus: SeatPreviewStatus;
  }): SeatPreviewState {
    return new SeatPreviewState(args.seatId, args.seatPreviewStatus);
  }

  static fromMap(context: SerializationContext, map: SerializedData): SeatPreviewState {
    return SeatPreviewState.create({
      seatId: MapUtils.getInteger(map, 'seatId'),
      seatPreviewStatus: toEnumFromString(MapUtils.getString(map, 'seatPreviewStatus'), SeatPreviewStatus),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'seatId': this.seatId,
      'seatPreviewStatus': this.seatPreviewStatus,
    };
  }

  clone(): this {
    return this.copyWith();
  }

  copyWith({
    seatId = this.seatId,
    seatPreviewStatus = this.seatPreviewStatus,
  }: {
    seatId?: number;
    seatPreviewStatus?: SeatPreviewStatus;
  } = {}): this {
    return SeatPreviewState.create({ seatId, seatPreviewStatus }) as this;
  }

  isSame(other: SeatPreviewState): boolean {
    return this === other || (
      this.seatId === other.seatId &&
      this.seatPreviewStatus === other.seatPreviewStatus
    );
  }
}

export class SeatPreviewStateBuilder extends DataModelBuilder<SeatPreviewState> {
  build(context: SerializationContext, map: SerializedData): SeatPreviewState {
    return SeatPreviewState.fromMap(context, map);
  }
}
